export default __webpack_public_path__ + "static/media/gallery_05.81da759e.jpg";